module.exports = ".botao-pesquisar {\n    margin-right: 5px;\n}\n\n.mover-para {\n    margin-top: 7px;\n    margin-left: 19px;\n    margin-right: 19px;\n}\n\n.imagem-nav {\n    margin-top: 20px;\n    margin-bottom: 10px;\n}\n\n.titulo {\n    font-family: 'Bree Serif', serif;\n    font-size: 36px !important;\n    color: #08307F;\n}\n\n.legenda {\n    font-size: 20px !important;\n    color: #08307F;\n}\n\n/* .col-valor {\n    width: 100px;\n    text-align: center;\n    word-wrap: break-word\n  } */"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.css
// module id = ./src/app/home/home.css
// module chunks = main